import { useMemo } from 'react';
import { useUserInfo } from '@/features/account/user-info';

function buildReferralLink(inviteCode: string, inviterName: string, inviteeReward: number): string {
    const encodedName = encodeURIComponent(inviterName);
    return `${window.location.origin}?gift=${inviteCode}&inviter=${encodedName}&inviteeReward=${inviteeReward}`;
}

export function useReferralLink(isOpen: boolean, inviteeReward: number): string {
    const { userInfo } = useUserInfo();
    const inviteCode = userInfo?.referral_code ?? '';
    const inviterName = userInfo?.name;

    return useMemo(() => {
        if (!isOpen || !inviteCode || !inviterName) {
            return '';
        }

        return buildReferralLink(inviteCode, inviterName, inviteeReward);
    }, [inviteCode, inviteeReward, inviterName, isOpen]);
}
